// import React from 'react';

// function SeniorManagement() {
//   // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=f3614e7d-3d6c-473e-9b4a-699cb84c853a&autoAuth=true&ctid=5ba5ef5e-3109-4e77-85bd-cfeb0d347e82";
//   const powerBiUrl = process.env.REACT_APP_Senior_Management;
//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  SeniorManagement;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function SeniorManagement() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='Senior_Management';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default SeniorManagement;
